import { FC } from 'react'

export interface BreadcrumbItem {
  label: string
  id?: number
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  onItemSelected?: (employeeId: number) => void
  lastItemSuffix?: string
}

const MAX_VISIBLE_CRUMBS = 4

const Breadcrumb: FC<BreadcrumbProps> = ({ items, onItemSelected, lastItemSuffix = '' }) => {
  const truncated = items.length > MAX_VISIBLE_CRUMBS
  const visible: (BreadcrumbItem | null)[] = truncated
    ? [items[0], null, items[items.length - 2], items[items.length - 1]]
    : items

  return (
    <ul className="flex">
      {visible.map((item, i) => (
        <li key={item?.id ?? item?.label ?? i}>
          {i > 0 && <span className="text-xl text-dark-blue-hover"> &nbsp;&nbsp;&nbsp;{'>'}&nbsp;&nbsp;&nbsp; </span>}
          {item === null ? (
            <span className="text-xl text-dark-blue-hover">…</span>
          ) : (
            <button
              className={`text-xl text-dark-blue-hover ${i === visible.length - 1 ? 'font-bold' : ''}`}
              onClick={() => onItemSelected?.(item.id as number)}
            >
              {i === visible.length - 1 ? item.label + lastItemSuffix : item.label}
            </button>
          )}
        </li>
      ))}
    </ul>
  )
}

export default Breadcrumb
